import React from 'react';
import SortingVisualizer from './SortingVisualizer/SortingVisualizer';
import './app.css';
function App() {
  return <SortingVisualizer />;
}

export default App;
